import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import HelpIcon from '@material-ui/icons/Help';
import FormHelperText from '@material-ui/core/FormHelperText';

import {
  CurrencyInputWrapper,
  ExpansionPanelWrapper,
  FormActionButtons,
  PopoverWrapper
} from 'components';

import { dailyValidate as validate } from './validate';

import { useStyles } from './styles';

const initialValues = {
  days: []
};

const DailyPricesFixed = ({
  handleSubmit,
  error,
  anyTouched,
  setSubmitButton,
  isUpdate
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.w}>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="days"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={false}
          getTitle={item => item.days.map(item => t(item)).join(', ')}
          children={(field, idx) => (
            <div className={classes.dailyCurrencyRow}>
              <div className={classes.row}>
                <Field
                  name={`${field}.NOK`}
                  label="NOK"
                  isHiddenErrorMsg={true}
                  className={classes.dailyCurrencyField}
                  component={CurrencyInputWrapper}
                />
                <Field
                  name={`${field}.EUR`}
                  label="EUR"
                  isHiddenErrorMsg={true}
                  className={classes.dailyCurrencyField}
                  component={CurrencyInputWrapper}
                />
                <Field
                  name={`${field}.USD`}
                  label="USD"
                  isHiddenErrorMsg={true}
                  className={classes.dailyCurrencyField}
                  component={CurrencyInputWrapper}
                />
                <PopoverWrapper text="Value for at least one currency for each category should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
                  <HelpIcon className={classes.helpIcon} />
                </PopoverWrapper>
              </div>
              {anyTouched && error && error[idx] && (
                <FormHelperText error>{t(error[idx].error)}</FormHelperText>
              )}
            </div>
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'pricesFixedForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(DailyPricesFixed);
